var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"outlined":"","color":_vm.color,"label":""}},[_vm._v(_vm._s(_vm._f("etatrequete")(_vm.etat)))])
}
var staticRenderFns = []

export { render, staticRenderFns }